import React from "react";

const CompanyStory = () => {
  return (
    <div className="about__tab_p">
      <h4>Company Story </h4>
      <p>
        Next Generation was founded in 2009. During our activity, we have made
        significant contributions to the development of online research. We
        continue to be one of the leading companies in our business with the
        innovations we bring.
      </p>
      <p>
        I would say... With its more than 250 thousand members, it conducts
        online market research for many of Turkey's leading companies.
      </p>
      <p>
        Collaborative work with Ipsos , the leader of the research industry in
        Turkey and the world giant , was initiated in 2014.
      </p>
    </div>
  );
};

export default CompanyStory;
